$(function() {
    if($('#instafeed').length) {
        var feed = new Instafeed({
            get: 'user',
            useHttp: true,
            limit: 4,
            resolution: 'standard_resolution',
            userId: 9379415623,
            accessToken: '9379415623.1677ed0.c7945e10f9a945d5b72891a305b0a76d',
            clientId: 'e0eff2492d584d8d855b60790ec2dc0f',
            template: '<div class="col-sm-2"><a href="{{link}}" target="blank"><img src="{{image}}"></a></div>'
        });
        feed.run();
    }
});
